"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tile = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const useFetchSvg_1 = __importDefault(require("../../../../common/helpers/Hooks/useFetchSvg"));
const WeatherIcon_1 = __importDefault(require("../../../../common/components/Weather/WeatherIcon"));
const react_router_dom_1 = require("react-router-dom");
const CardWrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background-color: ${props => props.theme.palette.mainAppColor.main};
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
  aspect-ratio: 2/1;
  padding: 13px;
  gap: 5px;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 1);
  }

  .weather-icon,
  .svg-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    max-height: 6vmin;
    width: 100%;

    i {
      height: 100%;
    }

    svg {
      width: 100%;
      height: 100%;

      path,
      circle {
        fill: ${props => (props.theme.palette ? props.theme.palette.mainAppColor.contrastText : '#000')};
      }
    }
  }
`;
const CardTitleWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const CardTitle = styled_components_1.default.p `
  color: ${props => props.theme.palette.mainAppColor.contrastText};
  font-size: 2vmin;
  margin: 0;
  letter-spacing: 0.1px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: center;
  overflow: hidden;
  hyphens: auto;
`;
const BackgroundImageWrapper = styled_components_1.default.div `
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;

  .sizing {
    min-height: 15vh;
  }

  .text {
    height: 82px;
    padding: 10px;
    position: relative;
    z-index: 3;
    color: #fff;
    text-shadow: 0px 1px black;
  }

  .bg-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${(props) => `url(${props.image} )`};
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  .bg-gradient {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.1) 50%, rgba(0, 0, 0, 0) 100%);
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 2;
  }
`;
const Tile = ({ withBackgroundImage, svg, title, withIcon, image, destination, onTileClick, symbol, currentLocale, }) => {
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const handleTileClick = () => {
        if (onTileClick) {
            onTileClick();
        }
        if (destination) {
            history.push({
                pathname: destination,
                search: location.search,
                state: { tileTitle: title },
            });
        }
    };
    if (withIcon && (svg || symbol)) {
        const loadedSvg = (0, useFetchSvg_1.default)(svg);
        return (react_1.default.createElement(CardWrapper, { className: "tile-wrapper", onClick: handleTileClick },
            symbol ? (react_1.default.createElement(WeatherIcon_1.default, { symbol: symbol })) : (react_1.default.createElement("div", { className: "svg-icon", dangerouslySetInnerHTML: {
                    __html: loadedSvg,
                } })),
            react_1.default.createElement(CardTitleWrapper, null,
                react_1.default.createElement(CardTitle, { lang: currentLocale }, title))));
    }
    if (withBackgroundImage) {
        return (react_1.default.createElement(BackgroundImageWrapper, { image: image, onClick: handleTileClick },
            react_1.default.createElement("div", { className: "bg-image" }),
            react_1.default.createElement("div", { className: "bg-gradient" }),
            react_1.default.createElement("div", { className: "sizing" }),
            react_1.default.createElement(CardTitle, { lang: currentLocale, className: "text" }, title)));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.Tile = Tile;
exports.default = exports.Tile;
